module.exports = __webpack_public_path__ + "img/3.c1545aa9.jpg";